import t, { forwardRef as o } from "react";
import { Link as s } from "../Link/Link.js";
import { cls as i } from "../../helpers/cls.js";
var y = Object.defineProperty,
  d = Object.defineProperties,
  O = Object.getOwnPropertyDescriptors,
  c = Object.getOwnPropertySymbols,
  b = Object.prototype.hasOwnProperty,
  x = Object.prototype.propertyIsEnumerable,
  _ = (r, a, e) => a in r ? y(r, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : r[a] = e,
  m = (r, a) => {
    for (var e in a || (a = {})) b.call(a, e) && _(r, e, a[e]);
    if (c) for (var e of c(a)) x.call(a, e) && _(r, e, a[e]);
    return r;
  },
  f = (r, a) => d(r, O(a)),
  p = (r, a) => {
    var e = {};
    for (var l in r) b.call(r, l) && a.indexOf(l) < 0 && (e[l] = r[l]);
    if (r != null && c) for (var l of c(r)) a.indexOf(l) < 0 && x.call(r, l) && (e[l] = r[l]);
    return e;
  };
const k = o((r, a) => {
  var e = r,
    {
      className: l
    } = e,
    n = p(e, ["className"]);
  return t.createElement(s, f(m({}, n), {
    ref: a,
    className: i("olx-alertbox__link", "olx-alertbox__link--error", l)
  }));
});
k.displayName = "ErrorLink";
const v = o((r, a) => {
  var e = r,
    {
      className: l
    } = e,
    n = p(e, ["className"]);
  return t.createElement(s, f(m({}, n), {
    ref: a,
    className: i("olx-alertbox__link", "olx-alertbox__link--info", l)
  }));
});
v.displayName = "InfoLink";
const N = o((r, a) => {
  var e = r,
    {
      className: l
    } = e,
    n = p(e, ["className"]);
  return t.createElement(s, f(m({}, n), {
    ref: a,
    className: i("olx-alertbox__link", "olx-alertbox__link--success", l)
  }));
});
N.displayName = "SuccessLink";
const u = o((r, a) => {
  var e = r,
    {
      className: l
    } = e,
    n = p(e, ["className"]);
  return t.createElement(s, f(m({}, n), {
    ref: a,
    className: i("olx-alertbox__link", "olx-alertbox__link--warning", l)
  }));
});
u.displayName = "WarningLink";
export { k as ErrorLink, v as InfoLink, N as SuccessLink, u as WarningLink };